import React, { useEffect, useRef } from 'react'
import classnames from 'classnames/bind'
import { gsap } from 'gsap'
import lottie from 'lottie-web'

// Components
import Button from '@/components/common/Button'

// Lib MISC
import animationData from '@/assets/lotties/recards_banner.json'

import styles from './style.scss'
import words from "@/assets/worddict.json"

const cx = classnames.bind(styles)

export const propTypes = {}

const BANNER_SPEED = 0.8

function Landing ({ lang }) {
  const lottieRef = useRef(null)
  const $t = words[lang]

  useEffect(() => {
    if (lottieRef.current) {
      lottie.loadAnimation({
        container: lottieRef.current, // the dom element
        loop: true,
        autoplay: true,
        animationData: animationData, // the animation data
      })

      lottie.setSpeed(BANNER_SPEED)
    }
  }, [])

  useEffect(() => {
    const scrollTl = gsap.timeline({})

    scrollTl.set('.move-from-left', { x: -20 })
    scrollTl.to('.move-from-left', { opacity: 1, x: 0, stagger: 0.2, duration: 1.5, ease: 'Power4.easeOut' })
    scrollTl.to('.slide-from-left', { opacity: 1 }, '<1')
    scrollTl.from('.slide-from-left', { clipPath: 'inset(0 100% 0 0)', duration: 1.3 }, '<0')

    return () => {
      scrollTl.kill()
    }
  }, [])

  const onCreateCardsClick = () => {
    window.location.href = 'https://create.re.cards/?page=step1'
  }

  return (
    <div className={cx('landing')}>
      <div className={cx('landing-wrap')}>
        <div className={cx('landing-wrap__content')}>
          <div className={cx('landing-wrap__content-card', 'slide-from-left')} data-zh={lang === 'zh'} />
          <div className={cx('landing-wrap__content-title')} data-zh={lang === 'zh'}>
            <p className={cx('landing-wrap__content-title-text', 'move-from-left')}>{$t.TXT_Landing_slogan1}</p>
            <p className={cx('landing-wrap__content-title-text', 'move-from-left', 'word-spacing')}>{$t.TXT_Landing_slogan2}</p>
            <p className={cx('landing-wrap__content-title-text', 'move-from-left')}>{$t.TXT_Landing_slogan3}</p>
          </div>
          <p className={cx('landing-wrap__content-description', 'move-from-left')}>{$t.TXT_Landing_slogan_description}</p>
          <div className={cx('landing-wrap__content-button', 'move-from-left')}>
            <Button className={cx('landing-wrap__content-button-item')} onClick={onCreateCardsClick}>
              {$t.TXT_Landing_create_your_cards_button}
            </Button>
          </div>
        </div>

        <div className={cx('landing-wrap-banner')}>
          <div className={cx('landing-wrap-banner-image')} ref={lottieRef} />
        </div>
      </div>
    </div>
  )
}

Landing.propTypes = propTypes

export default Landing
